import { NgModule }                      from '@angular/core';
import { SelectFilterBaseModule }        from '@shared/list-operations/components/select-filters/select-filter-base/select-filter-base.module';
import { SelectFilterContractComponent } from '@shared/list-operations/components/select-filters/select-filter-contract/select-filter-contract.component';


@NgModule( {
	declarations: [
		SelectFilterContractComponent
	],
	imports: [
		SelectFilterBaseModule
	],
	exports: [
		SelectFilterContractComponent
	]
} )
export class SelectFilterContractModule {}
